// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-prosemirror-components-Menu-Link-_A3QxV"};